import { useState, useEffect } from 'react';
import repo from 'service/repository';

const UseCoin = () => {
  const [coinType, setCoinType] = useState('enabled');
  const [ruleDialogOpen, setRuleDialogOpen] = useState(false);
  const [coinList, setCoinList] = useState([]);
  const [coinPage, setCoinPage] = useState(1);
  const [coinTotalPage, setCoinTotalPage] = useState(1);
  const [coinRules, setCoinRules] = useState();
  const [loading, setLoading] = useState(false);
  const [switchLoading, setSwitchLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      let result = await loadCoins(coinType);
      setCoinList(result.data);
      setCoinTotalPage(result.paging.totalPage);
      setSwitchLoading(false);

      let rulsResult = await repo.fetchCoinPageRulesBoard();
      setCoinRules(rulsResult[0]);
    };

    init();
  }, []); //eslint-disable-line

  const loadCoins = async (type, page = 1) => {
    return await repo.fetchMochiCoins({
      state: type === 'enabled' ? 'deposit' : 'withdraw',
      page,
    });
  };

  const switchCoins = async type => {
    setSwitchLoading(true);
    let result = await loadCoins(type);
    setCoinList(result.data);
    setCoinPage(1);
    setCoinTotalPage(result.paging.totalPage);
    setSwitchLoading(false);
  };

  const loadMoreCoins = async (type, newPage, callback) => {
    setLoading(true);
    await loadCoins(type, newPage).then(value => {
      setCoinList(prev => prev.concat(value.data));
      setCoinPage(newPage);
      setLoading(false);
      callback();
    });
  };

  return {
    loading,
    coinPage,
    coinTotalPage,
    coinType,
    setCoinType,
    ruleDialogOpen,
    setRuleDialogOpen,
    coinList,
    loadCoins,
    loadMoreCoins,
    coinRules,
    switchCoins,
    switchLoading,
  };
};

export default UseCoin;
